import dayjs from "dayjs";
import { OrderType } from "tm-shared/types";

export const generateOrderId = (
    type: OrderType = OrderType.H,
    orderNumber: number = 1,
    activeCollapse: string = "",
): string => {
    const dateStr = dayjs().format("YYYYMMDD");
    const marketSuffix =
        activeCollapse.split("-").pop()?.slice(0, 12) ?? "unknown";
    const orderId = `${dateStr}-${marketSuffix}-${type}${orderNumber}`;
    return orderId;
};
